import { diff as semverDiff } from 'semver';
import LocalStorage from './LocalStorageService';

const latestAppVersion = process.env.REACT_APP_VERSION;
const currentUserAppVersion = LocalStorage.getAppVersion();

const saveAppVersion = () => {
  LocalStorage.saveLatestAppVersion(latestAppVersion);
};

const setUpdateNotification = () => {
  LocalStorage.toggleUpdateNotification();
};

const checkAppVersion = () => {
  // semver returns null if the versions are identical
  const versionDiff = currentUserAppVersion
    ? semverDiff(currentUserAppVersion, latestAppVersion)
    : null;

  saveAppVersion();

  // on minor/major updates a notification must be shown
  if (versionDiff !== null && versionDiff !== 'patch') {
    setUpdateNotification();
  }

  // on any version update dump stored redux storage and hard reset the app to ensure new version is used
  if (versionDiff !== null) {
    LocalStorage.clearReduxLocalStorage();
    return window.location.reload(true);
  }
};

export default { checkAppVersion };
